import { Link } from "react-router-dom";
import { Instagram, Music2 } from "lucide-react";
import { useStore } from "../context/StoreContext";
import { BrandLogo } from "./BrandLogo";

export const Footer = () => {
  const { L } = useStore();
  const shopLinks = [
    { to: "/shop", label: L.nav.shopAll, id: "footer-shop-link" },
    { to: "/shop?collection=classiques", label: L.nav.classics, id: "footer-classics-link" },
    { to: "/shop?collection=melanges", label: L.nav.blended, id: "footer-blended-link" },
    { to: "/shop?collection=fruite", label: L.nav.fruity, id: "footer-fruity-link" },
  ];
  const houseLinks = [
    { to: "/story", label: L.nav.story, id: "footer-story-link" },
    { to: "/mission", label: L.nav.mission, id: "footer-mission-link" },
    { to: "/contact", label: L.nav.contact, id: "footer-contact-link" },
    { to: "/faq", label: L.nav.faq, id: "footer-faq-link" },
  ];
  const policyLinks = [
    ["shipping", "footer-policy-shipping"],
    ["returns", "footer-policy-returns"],
    ["lost-package", "footer-policy-lost"],
    ["donation", "footer-policy-donation"],
    ["privacy", "footer-policy-privacy"],
    ["terms", "footer-policy-terms"],
  ];

  return (
    <footer className="relative border-t border-gold/15 bg-onyx star-lattice" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-4">
            <BrandLogo emblemClass="h-14" textClass="text-[0.75rem]" testid="footer-logo" />
          </div>
          <p className="font-arabic text-gold text-2xl mt-2" dir="rtl">أَرِيجُ المِسْكِ</p>
          <div className="flex items-center gap-3 mt-6">
            <a
              data-testid="footer-instagram-link"
              href="https://www.instagram.com/arijmisk.mtl_/"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2.5 border border-gold/25 rounded-full text-ivory/80 hover:text-gold hover:border-gold/70 transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="w-4 h-4" strokeWidth={1.5} />
            </a>
            <a
              data-testid="footer-tiktok-link"
              href="https://www.tiktok.com/@arijmisk.mtl"
              target="_blank"
              rel="noopener noreferrer"
              className="p-2.5 border border-gold/25 rounded-full text-ivory/80 hover:text-gold hover:border-gold/70 transition-colors"
              aria-label="TikTok"
            >
              <Music2 className="w-4 h-4" strokeWidth={1.5} />
            </a>
            <span className="text-[0.7rem] tracking-[0.2em] text-ivory/60 ml-2">@ARIJMISK.MTL_</span>
          </div>
        </div>

        <div>
          <ul className="space-y-3 text-sm text-ivory/75">
            {shopLinks.map((l) => (
              <li key={l.id}><Link data-testid={l.id} className="hover:text-gold transition-colors" to={l.to}>{l.label}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <ul className="space-y-3 text-sm text-ivory/75">
            {houseLinks.map((l) => (
              <li key={l.id}><Link data-testid={l.id} className="hover:text-gold transition-colors" to={l.to}>{l.label}</Link></li>
            ))}
          </ul>
        </div>
      </div>

      <div className="hairline" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 pt-6">
        <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2">
          {policyLinks.map(([slug, id]) => (
            <li key={slug}>
              <Link data-testid={id} className="text-[0.62rem] tracking-[0.18em] uppercase text-ivory/45 hover:text-gold transition-colors" to={"/policies/" + slug}>
                {L.policies[slug].title}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6">
        <p className="text-center text-[0.65rem] tracking-[0.25em] text-ivory/50 uppercase" data-testid="footer-rights">{L.footer.rights}</p>
      </div>
    </footer>
  );
};
